<template>
	<v-card :loading="loading" height="500"  style="overflow-y: auto">
		<Detalhes :mostrar="showModalDetalhes" :evento="registro" @fecharDetalhes="close()" @eventoRecusado="atualizarEventosRecusado($event)" @eventoConfirmado="atualizarEventosConfirmado($event)"/>
		<Doacoes :mostrar="showModalDoacoes" :evento="registro" :doacoes="doacoes" @fecharDoacoes="close()"/>
		<v-card-title class="justify-center">{{titulo}}</v-card-title>
		<v-card-text>
			<v-row class="corpo">
				<v-col v-for="ev in eventos" :key="ev.id" cols="12" class="col-sm-6">
					<v-hover v-slot:default="{hover}">
					<v-card  class="mx-auto" :elevation="hover ? 16 : 2">
						<v-card-title class="py-2" :style="hexToRgbA(ev.cor_evento)">{{ev.titulo}}</v-card-title>
						<v-card-text class="pt-4">
							<h4>{{ev.descricao_tipo}}</h4>
							<h2 class="text--prymary">{{ev.data_evento}} - {{ev.inicio}}</h2>
							<h3 class="text--prymary">{{ev.descricao_local}}</h3>
							<br />
							<p>Para iniciados a partir de {{ev.grau}}º grau.<br />
							Atividade realizada por {{ev.nome_iniciado}}.<br />
							Sua confirmação: {{ev.confirmacao}}</p>
						</v-card-text>
						<v-card-actions :style="bgEvento(ev)">
							<v-spacer></v-spacer>
							<h3 v-if="ev.status_evento == 0">Essa atividade está cancelada.</h3>
							<div v-else>
							<v-btn @click="abrirDetalhes(ev)" text color="primary">Detalhes</v-btn>
							<v-btn @click="abrirDoacoes(ev)" text color="primary">Doações</v-btn>
							</div>
						</v-card-actions>
					</v-card>
					</v-hover>
				</v-col>
			</v-row>
		</v-card-text>
	</v-card>
</template>

<script>
	import {baseApiUrl, showError} from '@/config/global'
	import { mapState } from 'vuex'
	import axios from 'axios'
	import Detalhes from '@/components/home/Detalhes'
	import Doacoes from '@/components/home/Doacoes'

	export default{
		name: 'ProximosEventos',
		props: ['titulo'],
		
		computed:{
			... mapState(['user']),
		},
		components: {Detalhes, Doacoes}, 
		data(){
			return{
				showModalDetalhes: false,
				showModalDoacoes: false,
				buscandoEventos: true,
				cadastrarDoacao: false,
				itens: [],
				itemDoacao: {},
				doacoes:{
					headers:[
						{text: 'Código', value: 'id_item', align: 'center', divider: true},
						{text: 'Nome', value: 'nome', align: 'center', divider: true},
						{text: 'Qtd', value: 'quantidade', align: 'center', divider: true},
						{text: 'Qtd pendente', value: 'qtd_pendente', align: 'center', divider: true},
						{text: 'Und', value: 'nome_unidade', align: 'center', divider: true},
						{text: 'Ações', value: 'action', align: 'center', divider: true}
					],
					itens:[

					],
					registros: {},
					loading: false,
				},
				registro: {},
				eventos: {},
				loading: false,
			}
		},

		methods:{
			atualizarEventosRecusado(ev){
				this.eventos.forEach((v, i) => {
					if(v.id == ev){
						this.eventos[i].confirmacao = "recusado"
					}
				})
			},
			atualizarEventosConfirmado(ev){
				this.eventos.forEach((v, i) => {
					if(v.id == ev){
						this.eventos[i].confirmacao = "confirmado"
					}
				})
			},
			hexToRgbA(hex){
				var c;
				if(/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)){
					c= hex.substring(1).split('');
					if(c.length== 3){
						c= [c[0], c[0], c[1], c[1], c[2], c[2]];
					}
					c= '0x'+c.join('');
					let cor = 'background-color: rgba('+[(c>>16)&255, (c>>8)&255, c&255].join(',')+',0.7); color: white'
					return cor
				}
				throw new Error('Bad Hex');
			},
			bgEvento(ev){
				
				if(ev.status_evento == 1){
					if(ev.confirmacao == 'confirmado'){
						return 'background-color: rgba(100, 250, 100, 0.5)'
					}else if(ev.confirmacao == 'recusado'){
						return 'background-color: rgba(250, 0, 0, 0.3)'
					}else{
						return 'background-color: rgba(250, 250, 100, 0.5)'
					}
				}else{
					return 'background-color: rgba(0,0,0,0.1)'
				}
				
			},

			abrirDetalhes(registro){
				this.registro = registro
				this.showModalDetalhes = true
			},

			abrirDoacoes(registro){
				this.registro = registro
				this.doacoes.itens = []
				this.buscaItens()
			},

			close(){
				this.showModalDetalhes = false
				this.showModalDoacoes = false
			},

			

            buscaItens(){

				const url = `${baseApiUrl}/itensEventos/read.php?id_evento=${this.registro.id}`
				axios.get(url)
				.then(res => {
					
					if(res.data.codigo == '01'){
					
						this.doacoes.itens = res.data.dados.itens
						this.showModalDoacoes = true
						
					}else if(res.data.codigo == "02"){
						showError(res.data.mensagem)
					}
				})
			},

			buscaEventos(){
				
				this.loading = true

				const url = `${baseApiUrl}/home/proximosEventos.php?grau=${this.user.outros.grauAtual}&iniciado=${this.user.iniciado}`

				axios(url)
					.then(res => {
						this.eventos = res.data.dados.map(txt => {
							return{
								...txt,
							}
						})
					this.loading = false	
					})
					.catch({showError})
			},
		},

		watch:{
			registros(){
				this.buscandoEventos = !this.buscandoEventos
			},

			'itemDoacao.qtd_doacao'(){
				this.itemDoacao.qtd_pendente = this.itemDoacao.quantidade - this.itemDoacao.qtd_doacao
			}
		},

		created(){
			this.buscaEventos()
		}
	}

</script>

<style scoped>
.titulo{
	text-align: center;
}

.corpo{
	height: calc(70vh - 200px);
}
	.mensagem{
		width: 100%;
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;

	}
	.registros-eventos{
		position: relative;
		display: flex;
		flex-direction: column;
		flex-wrap: wrap;
		justify-content: space-between;
		height: 70vh;
		width: 90%;
		padding: 20px 10px 10px 10px;
		background-color: rgba(230, 230, 230, 0.2);
		border-radius: 6px;
		box-shadow: 3px 3px 6px rgb(0,0,0,0.5);
		overflow-y: auto;
		margin: 0 auto;
		
	}

	div.registros-eventos div.corpo-itens{
		height: 450px;
		display: flex;
		flex-direction: column;
		
	}


	
	.registros-eventos .item-texto{
		font-size: 0.7rem;
		width: 100%;
		height: 100px;
		padding: 8px;
		background-color: var(--cor-compl);
		box-shadow: 4px 4px 8px rgba(0,0,0,0.1);
		margin-top: 4px;
		display: flex;
		flex-direction: row;
	}

	.registros-eventos .campos{
		width: 85%;
		display: flex;
		flex-direction: column;
	}

	.registros-eventos .evtBotoes{
		width: 15%;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}



	.registros-eventos h1{
		font-size: 1.8rem;
		text-align: center;
	}

	.item-texto{
		font-size: 0.7rem;
	}

	.item-texto h2{
		font-size: 1.1rem;
		padding-left: 8px;
	}

	.item-texto .dados{
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
	}

	#btn-doacao{
		z-index: 100;
	}
</style>